import { render, staticRenderFns } from "./EmailModel.vue?vue&type=template&id=080a848c&scoped=true"
import script from "./EmailModel.vue?vue&type=script&lang=js"
export * from "./EmailModel.vue?vue&type=script&lang=js"
import style0 from "./EmailModel.vue?vue&type=style&index=0&id=080a848c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a848c",
  null
  
)

export default component.exports